import React, { useEffect, useState } from 'react'
import { makeStyles, withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import AssignmentIcon from "@material-ui/icons/Assignment";
import SearchIcon from "@material-ui/icons/Search";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import BusinessIcon from "@material-ui/icons/Business";
import StepConnector from "@material-ui/core/StepConnector";
import PeopleIcon from '@material-ui/icons/People';
import Button from "@material-ui/core/Button";
import { traerAfliadoPorCuilWeb } from '../../../../actions/preAfiliado/afiliado';
import { useDispatch, useSelector } from 'react-redux';
import { limpiarSeleccionFamiliar } from '../../../../actions/familiarSeleccionado';
import { changeStepper } from '../../../../actions/preAfiliado/stepper';
import { BuscadorCuil } from '../../BuscadorCuil';
import { TabIngresoTitularWeb } from './TabIngresoTitularWeb';
import { Grid, Zoom } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { AlertFinalizadoStepper } from '../../../stepper/AlertFinalizadoStepper';
import { BannerAfiliadoWeb } from './BannerAfiliadoWeb';
import { fetchSeccionales } from '../../../../actions/cbos/seccionales';
import { fetchCategorias } from '../../../../actions/cbos/categorias';
import { fetchLocalidades } from '../../../../actions/cbos/localidades';
import { fetchProvincias } from '../../../../actions/cbos/provincias';
import { FormularioEmpresaPreAfiliadoWeb } from './FormularioEmpresaPreAfiliadoWeb';
import { useFormNew } from '../../../../hooks/useFormNew';
import { DocumentacionPreAfiliadoWeb } from './DocumentacionPreAfiliadoWeb';
import { GrupoFamiliarPreAfiliadoWeb } from './GrupoFamiliarPreAfiliadoWeb';
import { empresaLimpiar } from '../../../../actions/empresas/empresas';

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage:
        "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    },
  },
  completed: {
    "& $line": {
      backgroundImage:
        "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundImage:
      "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SearchIcon />,
    2: <GroupAddIcon />,
    3: <BusinessIcon />,
    4: <PeopleIcon />,
    5: <AssignmentIcon />
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginBottom: 10,
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  buttonRoot: {
    margin: 30,
  },
  rootListadoc: {
    margin: 30,
  },
}));

function getSteps() {
  return [
    "Búsqueda por Cuil",
    "Complete sus datos",
    "Cargue Empresa",
    "Familia",
    "Documentación / Certificados"
  ];
}

export const StepperIngresoWeb = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  let history = useHistory();

  const [open, setOpen] = React.useState(false);
  const [cuil, setCuil] = useState("");
  const [personaInactiva, setPersonaInactiva] = useState(true);
  const [habilitado, setHabilitado] = React.useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);

  const initialValuesAfiliado = {
    // EMPRESA
    cuit_Empresa: "",
    ingreso_Bruto: "",
    // FAMILIA
    familia: "",
    cobertura: "",
    origen: "",
    observacion_Origen: "",
    documentacion: []
  }
  const { formValues, setearValor, setFormValues, reset } = useFormNew(initialValuesAfiliado)

  const fromBandeja = false;

  const { step } = useSelector((state) => state.stepper);
  const { afiliadoEncontrado } = useSelector((state) => state.preinscripto);
  const steps = getSteps();

  useEffect(() => {
    dispatch(fetchSeccionales());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchCategorias());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchLocalidades());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchProvincias());
  }, [dispatch]);

  const handleNext = () => {
    switch (step) {
      case 0:
        // dispatch(desSeleccionarAfiliadoNuevo());
        traerDataAfiliado();
        break;
      case 1:
        document.querySelector(`#btnsubmit`).click();
        break;
      case 2:
        dispatch(limpiarSeleccionFamiliar());
        document.querySelector(`#btnsubmitEmpresa`).click();
        break;
      case 3:
        document.querySelector(`#btnsubmitGrupoFamiliar`).click();
        break;
      case 4:
        dispatch(changeStepper(step + 1));
        setOpenAlert(true)
        break;
      default:
        break;
    }
  };

  const traerDataAfiliado = () => {
    if (cuil.length < 11) {
      setOpen(true);
      dispatch(changeStepper(0));
    } else {
      dispatch(traerAfliadoPorCuilWeb(cuil));
      dispatch(changeStepper(step + 1));
    }
  };

  const resetStepper = () => {
    dispatch(changeStepper(0));
    dispatch(empresaLimpiar())
    reset()
    setCuil("")
  };

  const handleBack = () => {
    if (step === 1) return resetStepper()
    if (step === 2) return setHabilitado(false);
    if (step === 4) return resetStepper()
    dispatch(changeStepper(step - 1));
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const onChangeCuil = (e) => {
    let reg = new RegExp("^[0-9]+$");
    if (
      e.target.value === "" ||
      reg.test(e.target.value) ||
      isNaN(e.target.value)
    ) {
      if (isNaN(e.target.value)) {
        setCuil("");
      } else {
        setCuil(e.target.value);
      }
    }
  };

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      dispatch(traerAfliadoPorCuilWeb(e.target.value));
      dispatch(changeStepper(step + 1));
    }
  }

  const getStepContent = (escalon) => {
    switch (escalon) {
      case 0:
        return (
          <BuscadorCuil
            handleClose={handleClose}
            cuil={cuil}
            open={open}
            onChangeCuil={onChangeCuil}
            onKeyDown={onKeyDown}
          />
        )
      case 1:
        if (afiliadoEncontrado) {
          return (
            <TabIngresoTitularWeb
              idTabIngreso={"idTabTitularModi"}
              form={{
                formValues,
                setearValor,
                setFormValues
              }}
            />
          )
        }
        break;
      case 2:
        return (
          <Grid className={classes.rootListadoc}>
            <FormularioEmpresaPreAfiliadoWeb
              afiliado={afiliadoEncontrado}
              setHabilitado={setHabilitado}
              fromBandeja={fromBandeja}
              form={{
                formValues,
                setearValor
              }}
            />
          </Grid>
        )
      case 3:
        return (
          <Zoom style={{ transitionDelay: "100ms" }} in={true}>
            <Grid className={classes.rootListadoc}>
              <GrupoFamiliarPreAfiliadoWeb
                afiliado={afiliadoEncontrado}
                form={{
                  formValues,
                  setearValor
                }}
              />
            </Grid>
          </Zoom>
        )
      case 4:
        return (
          <Grid className={classes.rootListadoc}>
            <DocumentacionPreAfiliadoWeb
              form={{
                formValues,
                setearValor
              }}
            />
          </Grid>
        )
      default:
        return "Unknown step";
    }
  };

  const HandleCloseQuestion = () => {
    setPersonaInactiva(false);
    history.push("/afiliado/formularioAfiliacion");
  };
  const HandleConfirmar = () => {
    setPersonaInactiva(false);
  }

  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={step}
        connector={<ColorlibConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {
        step === steps.length
          ?
          <AlertFinalizadoStepper
            open={openAlert}
            pregunta={"¿Esta seguro que desea enviar la documentación?"}
            dialogText={"Recuerde que no podra modificar los datos. Aguarde que lo contacte un analista."}
            buttonCancel={"Cancelar"}
            buttonSubmit={"Enviar"}
            handleClose={() => resetStepper()}
            handleSend={() => resetStepper()}
          />
          :
          <div>
            <Grid container justify="center">
              {
                (step !== 0 || (fromBandeja && step === 0)) &&
                <Grid item xs={12} style={{ marginTop: "1rem" }}>
                  {(afiliadoEncontrado) && <BannerAfiliadoWeb />
                  }
                </Grid>
              }
              {getStepContent(step)}
            </Grid>
            {afiliadoEncontrado?.nro_doc === 0 && (step === 1) && (
              <AlertFinalizadoStepper
                open={personaInactiva}
                pregunta={"Persona Inactiva"}
                dialogText={`Esta persona se encuentra inactiva en AFIP. Desea cargarla de igual manera?`}
                buttonCancel={"Cancelar"}
                buttonSubmit={"Confirmar"}
                handleClose={HandleCloseQuestion}
                handleSend={HandleConfirmar}
              />
            )}
            <Grid
              className={classes.buttonRoot}
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Button
                variant="contained"
                disabled={step === 0}
                onClick={handleBack}
                className={classes.button}
                color="secondary"
              >
                {(step === 1 || step === 4) ? "Elegir otro cuil" : "Anterior"}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                className={classes.button}
                disabled={habilitado}
              >
                {step === steps.length - 1 ? "Finalizar" : step === 3 ? "Guardar Información" : "Siguiente"}
              </Button>
            </Grid>
          </div>
      }
    </div>
  );
}
